import { map } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LocalStorageService } from 'ngx-webstorage';

@Injectable()
export class AuthServerProvider {
    constructor(
        private http: HttpClient,
        private $localStorage: LocalStorageService
    ) {}

    getToken() {
        return this.$localStorage.retrieve('authenticationToken');
    }

    hasValidToken() {
        return !!this.getToken();
    }

    login(credentials): Observable<any> {
        let data =
            'j_username=' +
            encodeURIComponent(credentials.username) +
            '&j_password=' +
            encodeURIComponent(credentials.password) +
            '&remember-me=' +
            credentials.rememberMe +
            '&submit=Login';
        let headers = new HttpHeaders({
            'Content-Type': 'application/x-www-form-urlencoded',
        });

        return this.http.post('api/authentication', data, {
            headers,
        });
    }

    logout(): Observable<any> {
        // logout from the server
        return this.http.post('api/logout', {}).pipe(
            map((response: Response) => {
                this.$localStorage.clear('authenticationToken');
                // to get a new csrf token call the api
                this.http.get('api/account').subscribe(
                    () => {},
                    () => {}
                );
                return response;
            })
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/auth/auth-session.service.ts